import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const createBusinessRole = (params) => {
  return Api(endPoints.businessCreateRole, params, requestType.POST);
};
export const fetchBusinessRole = (id) => {
  return Api(`${endPoints.fetchBusinessRole}/${id}`, null, requestType.GET);
};
export const updateRole = (id, businessId, params) => {
  return Api(
    `${endPoints.updateRole}/${id}/${businessId}`,
    params,
    requestType.PUT
  );
};
export const getSinglePackagesData = (id) => {
  return Api(`${endPoints.getSinglePackagesData}/${id}`, null, requestType.GET);
};
export const deletePackages = (id) => {
  return Api(`${endPoints.deletePackage}/${id}`, null, requestType.GET);
};
